// Hợp đồng API của module `bolero` — key kích hoạt phần mềm BOLERO RENDER (chạy trên máy nhân viên) cấp từ web.
import { z } from 'zod';
/** Mã máy phần mềm hiện cho nhân viên: «M-» + 12 ký tự hex chia ba nhóm (phần mềm tự tính từ Windows). */
export const BOLERO_MACHINE_CODE_PATTERN = /^M-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}$/;
/** Thời hạn chọn sẵn trên form (số ngày); 0 = vĩnh viễn. */
export const BOLERO_EXPIRY_PRESETS = [30, 90, 180, 365, 0];
export const boleroKeyCreateSchema = z.object({
    /** Tên hiện trong phần mềm («Cấp cho …»). */
    issuedTo: z.string().trim().min(1, 'Chưa ghi cấp cho ai').max(80),
    /** Tài khoản web của người nhận, để đối chiếu trong sổ; '' = không gắn tài khoản. */
    username: z.string().trim().max(64).default(''),
    /**
     * Mã máy BẮT BUỘC — mỗi key chỉ chạy trên một máy (chốt 29/09/2026). Vẫn `default('')` để máy chủ kiểm và
     * báo lỗi bằng tiếng Việt thay vì «Dữ liệu gửi lên không hợp lệ».
     */
    machineCode: z.string().trim().default(''),
    /** Số ngày hiệu lực kể từ hôm nay; 0 = vĩnh viễn. Bị bỏ qua khi có `expiresOn`. */
    days: z.number().int().min(0).max(3650).default(0),
    /** Ngày hết hạn cụ thể 'YYYY-MM-DD' ('' = theo `days`). */
    expiresOn: z.string().trim().default(''),
    note: z.string().trim().max(200).default(''),
});
export const boleroKeyParamsSchema = z.object({ id: z.coerce.number().int().positive() });
//# sourceMappingURL=bolero.js.map